<template>
    <numbering-check-settings
        model-name="purchaseinvoice"
        document-label="le fatture di acquisto"
    />
</template>

<script>
import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

export default {
    name: 'purchaseinvoices-other',
    components: {
        NumberingCheckSettings
    }
}
</script>
